import * as React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import {KPI_PRICING} from "@constants";
import {kpiPrice} from "@signals";


const OPTIONS = [
    { label: 'Current Price', value: KPI_PRICING.ACTUAL },
    { label: 'List Price', value: KPI_PRICING.LIST }
]

export default function PricingSkuEvolutionKpiSelect() {

    return <SelectSeeker
        options={OPTIONS}
        label="KPI Price"
        value={kpiPrice.value}
        onChange={e => kpiPrice.value = e.target.value}
    />
}